import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brTablet = createBreakpoint('s');
const br360 = createBreakpoint('xs');

export const mainCls = 'tagButton';

export default {
  [mainCls]: {},
  [`${mainCls}__item`]: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '4px',
    border: `1px solid #EFF2F5`,
    '&:hover': {
      border: `1px solid ${colors.border.rgba}`,
    },
    '&:active': {
      border: `1px solid ${colors.f0.rgba}`,
    },
  },
  [`${mainCls}__item--b`]: {
    fontWeight: 'normal',
  },
  [`${mainCls}__item--ctn`]: {
    pointerEvents: 'none',
  },
  [`${mainCls}--ctn`]: {
    display: 'flex',
    flexWrap: 'nowrap',
    maxWidth: '200px',
    [br360]: {
      maxWidth: '100%',
    },
    [brTablet]: {
      '&:hover': {
        '& .icon': {
          color: colors.f0.rgba,
        },
      },
    },
  },
  [`${mainCls}--label`]: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    [br360]: {
      overflow: 'auto',
      whiteSpace: 'wrap',
      textOverflow: 'none',
    },
    flexWrap: 'nowrap',
  },
  [`${mainCls}__item--del`]: {
    height: '14px',
    color: colors.f3.rgba,
  },
};
